import { Grid } from "antd";
import { Navigate, useParams } from "react-router-dom";
import { Recovery } from "./Recovery";
import { SignIn } from "./SignIn";
import { SignUp } from "./SignUp";
const { useBreakpoint } = Grid;

export function SignInGeneral() {
  const { pageId } = useParams();
  const screens = useBreakpoint();

  return (
    <>
      <section
        style={{
          alignItems: "center",
          display: "flex",
          height: "100vh",
        }}
      >
        {{
          recovery: <Recovery />,
          signup: <SignUp />,
          signin: <SignIn />,
        }[pageId || ""] || <Navigate to="/signin" />}
        {screens.lg && (
          <div
            style={{
              width: "50%",
              height: "100%",
              overflow: "hidden",
            }}
          >
            <img
              loading="lazy"
              src="/assets/login_bg.png"
              alt="SignUp Background"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </div>
        )}
      </section>
    </>
  );
}
